export const msalConfig = {
  auth: {
    clientId: "7515bb31-2dc0-4858-911b-e09bb2f25fe0",
    authority: "https://login.microsoftonline.com/405f07c7-a28c-4624-854e-820e6e6dcec8",
    redirectUri: "https://vault.hopscotchgroupe.info",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphGroupsEndpoint: "https://graph.microsoft.com/v1.0/me/memberOf",
};

export const apiConfig = {
  baseUrl: "https://hopscotch-archives-api-d0a3dth5b9bdbkey.francecentral-01.azurewebsites.net/api",
};